import React from "react";
import DataAccordion from "@/components/ui/data-accordion";
import LazyImage from "@/components/lazy-image";
import { ProductItemInterface } from "@/assets/interfaces";

interface InfoBlocksSectionProps {
  infoBlocks: ProductItemInterface["info_blocks"];
}

interface TextInfoBlockProps {
  title: string;
  text: string;
}

interface ImagesInfoBlockProps {
  title: string;
  images: string[];
}

export const TextInfoBlock = ({ title, text }: TextInfoBlockProps) => {
  return (
    <DataAccordion defaultClosed={true} title={title}>
      <div className="w-full">
        <p className="leading-snug text-dark transition-all ease-out duration-200 text-xs md:text-1xs lg:text-1xs mt-3 whitespace-pre-line">
          {text}
        </p>
      </div>
    </DataAccordion>
  );
};

export const ImagesInfoBlock = ({ images, title }: ImagesInfoBlockProps) => {
  return (
    <DataAccordion defaultClosed={true} title={title}>
      <div className="flex items-center flex-wrap gap-2.5">
        {images && images.map((image, index) => (
          <div key={index}>
            <figure
              className="w-24 h-24 md:w-30 md:h-30 border border-grey-fields-100 rounded-10 relative group"
              key={index}
            >
              <LazyImage
                src={image}
                alt={""}
                className="w-full h-full object-cover rounded-10"
                loaderClasses="rounded-10"
              />
            </figure>
          </div>
        ))}
      </div>
    </DataAccordion>
  );
};

const InfoBlocksSection = ({ infoBlocks }: InfoBlocksSectionProps) => {
  if (!infoBlocks?.length) return null;

  return (
    <div className="flex mt-8 flex-col gap-y-2 border-t border-grey-border border-opacity-50 divide-y divide-opacity-50 divide-grey-border">
      {infoBlocks.map((block, index) => (
        <div className="pt-5" key={index}>
          {block.content_type === "TEXT" ? (
            <TextInfoBlock title={block.title} text={block.text_content} />
          ) : (
            <ImagesInfoBlock images={block.image_content} title={block.title} />
          )}
        </div>
      ))}
    </div>
  );
};

export default InfoBlocksSection;
